import Enum from '@/zenky/interfaces/common/Enum';
import Price from '@/zenky/interfaces/common/Price';
import DateTime from '@/zenky/interfaces/common/DateTime';
import { CustomerV2, CustomerV3, v2ToV3 as customerV2ToV3 } from '@/zenky/interfaces/customers/Customer';
import EntityAddress from '@/zenky/interfaces/common/addresses/EntityAddress';
import City from '@/zenky/interfaces/store/City';
import Stock from '@/zenky/interfaces/store/Stock';
import OrderProductVariant from '@/zenky/interfaces/orders/OrderProductVariant';
import OrderStatusKind from '@/zenky/interfaces/orders/OrderStatusKind';
import OrderConfirmationStatus from '@/zenky/interfaces/orders/OrderConfirmationStatus';
import DeliveryMethod from '@/zenky/interfaces/orders/DeliveryMethod';
import PaymentMethod from '@/zenky/interfaces/orders/PaymentMethod';
import OrderStatusChange from '@/zenky/interfaces/orders/OrderStatusChange';
import OrderPaymentsSummary from './payments/Summary';
import OrderPaymentTransaction from './payments/Transaction';
import { Omit } from 'lodash'; // Can remove when we upgrade TypeScript.

interface OrderV2 {
  id: string;
  number: string;
  token?: string;
  source?: string;
  status: Enum<OrderStatusKind>;
  confirmation_status: Enum<OrderConfirmationStatus>;
  delivery_method: Enum<DeliveryMethod>;
  payment_method: Enum<PaymentMethod>;
  total_price: Price;
  expected_payment_amount: Price;
  amount_paid: Price;
  bonuses_amount_paid: Price;
  bonuses_transaction_id: string;
  bonuses_transaction_confirmed: boolean;
  notes: string;
  created_at: DateTime;
  updated_at: DateTime;
  submitted_at: DateTime | null;
  variants?: OrderProductVariant[];
  customer_address?: EntityAddress;
  customer?: CustomerV2 | {};
  delivery_address?: EntityAddress | null;
  city?: City | {};
  stock?: Stock | {};
  statuses?: OrderStatusChange[];
  payments_summary?: OrderPaymentsSummary;
  payments?: OrderPaymentTransaction[];
  current_status: OrderStatusChange & Required<Pick<OrderStatusChange, 'status'>>;
  deliver_at: DateTime | null;
}
type Order = OrderV2;
export default Order;

// Make it just `Order` when we upgrade API.
export interface OrderV3 extends Omit<OrderV2, 'customer' | 'city' | 'stock'> {
  customer?: CustomerV3 | null;
  city?: City | null;
  stock?: Stock | null;
}

export function v2ToV3(orderV2: OrderV2): OrderV3 {
  const propsToConvert: ['customer', 'city', 'stock'] = ['customer', 'city', 'stock'];
  const testKey: keyof CustomerV2 | keyof City | keyof Stock = 'created_at';
  const toBeOrderV3 = {
    ...orderV2,
  };
  propsToConvert.forEach((prop) => {
    const val = orderV2[prop];
    if (val !== undefined && !(testKey in val)) {
      // It's an empty object.
      (toBeOrderV3 as OrderV3)[prop] = null;
    }
  })
  if (toBeOrderV3.customer !== undefined && toBeOrderV3.customer !== null) {
    customerV2ToV3(toBeOrderV3.customer as CustomerV2);
  }
  return toBeOrderV3 as OrderV3;
}
